<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoHuntAreas">No hunt areas found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <table class="table is-fullwidth is-striped" v-if="hasNoHuntAreas == false && isLoading == false">
      <thead>
        <tr>
          <th>Name</th>
          <th>Id</th>
          <th>County</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="huntArea in huntAreas" :key="huntArea.id">
          <td>
            <span>{{ huntArea.name }}</span>
          </td>
          <td>
            {{ huntArea.id }}_LLGroup
          </td>
          <td>
            <span>{{ huntArea.county }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";

import {
  LOAD_HUNT_AREAS,
  IS_LOADING_HUNT_AREAS,
  GET_HUNT_AREAS,
  GET_HUNT_AREAS_LOAD_ERROR,
  HAS_EMPTY_HUNT_AREAS_LOAD_RESULT
} from "./gamecamStore";

export default {
  name: "GamecamHuntAreasTab",

  components: {
    Spinner
  },

  props: {
    gamecamStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    const loadHuntAreasAction = `${this.gamecamStorePath}/${LOAD_HUNT_AREAS}`;
    this.$store.dispatch(loadHuntAreasAction);
  },

  computed: {
    huntAreasLoaded() {
      return this.huntAreas !== null;
    },

    isLoading() {
      const isLoadingHuntAreas = `${this.gamecamStorePath}/${IS_LOADING_HUNT_AREAS}`;
      return this.$store.getters[isLoadingHuntAreas];
    },

    hasNoHuntAreas() {
      const hasEmptyHuntAreasLoadResult = `${this.gamecamStorePath}/${HAS_EMPTY_HUNT_AREAS_LOAD_RESULT}`;
      return this.$store.getters[hasEmptyHuntAreasLoadResult];
    },

    huntAreas() {
      const getHuntAreas = `${this.gamecamStorePath}/${GET_HUNT_AREAS}`;
      return this.$store.getters[getHuntAreas];
    },

    loadError() {
      const getHuntAreasLoadError = `${this.gamecamStorePath}/${GET_HUNT_AREAS_LOAD_ERROR}`;
      return this.$store.getters[getHuntAreasLoadError];
    }
  }
};
</script>
